import { defineMessages } from 'react-intl';

export default defineMessages({
    requestReceived: {
        id: 'adac.callback-options-page.Your request has been received',
        defaultMessage: 'Your request has been received'
    },
    nextStep: {
        id: 'adac.callback-options-page.Next step',
        defaultMessage: 'Next step'
    },
    adacCallback: {
        id: 'adac.callback-options-page.ADAC callback',
        defaultMessage: 'ADAC callback'
    },
    pleaseHoldYourPhone: {
        id: 'adac.callback-options-page.Callback information',
        defaultMessage: 'We will call you back in the next { option }. Please keep your phone free.'
    },
    nextButton: {
        id: 'adac.callback-options-page.Next',
        defaultMessage: 'Next'
    },
    backButton: {
        id: 'adac.callback-options-page.Back',
        defaultMessage: 'Back'
    },
    recallAlreadyPlanned: {
        id: 'adac.callback-options-page.Your recall is planned, please wait for contact',
        defaultMessage: 'Your recall is planned, wait for contact'
    },
    close: {
        id: 'adac.callback-options-page.Close',
        defaultMessage: 'Close'
    },
});
